module.exports = __webpack_public_path__ + "static/img/17063B_1_2_R_20220623_fit.16a42ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17063B_1_2_R_20220623_fit.png
// module id = 277J
// module chunks = 0